module.exports = __webpack_public_path__ + "static/media/DSC_2736.a458f1d9.jpg";